import React from 'react'
import { Box } from '@mui/material'
import BlueRibbon from '../BlueRibbon/blueRibbon'
import GreenRibbon from '../GreenRibbon/greenRibbon'

interface CouponCardRibbonProps {
    desiredPoints: number
}

const couponCardRibbon = ({ desiredPoints }: CouponCardRibbonProps) => {
  return (
    <React.Fragment>
        <Box sx={{position: "absolute", top: "0px", right: "0px", width: "100%", height: "100%"}}>
            {
                desiredPoints <= 0 ? <GreenRibbon /> : desiredPoints <= 100 ? <BlueRibbon desiredPoints={desiredPoints}/> : null
            }
        </Box>
    </React.Fragment>
  )
}

export default couponCardRibbon
